import { useMemo, useState } from "react";
import Pagination from "../../components/Pagination/Pagination";
import { TableBody } from "../TablesBasePage/TableBody";
import { TableHeader } from "../TablesBasePage/TableHeader";

const designCombinationsHeaderDefinitions = {
  header: [
    {
      columns: [
        {
          title: "order",
          path: "order",
          type: "number",
          valuetype: "number",
          filtered: false,
          disabled: false,
          translationKey: "tables.designcombinations.order",
          translationNamespace: "tables",
        },
        {
          title: "name",
          path: "name",
          disabled: false,
          filtered: false,
          type: "string",
          translationKey: "tables.designcombinations.name",
          translationNamespace: "tables",
        },
        {
          title: "deadLoadFactor",
          path: "deadLoadFactor",
          type: "number",
          valuetype: "number",
          filtered: false,
          disabled: false,
          translationKey: "tables.designcombinations.deadLoadFactor",
          translationNamespace: "tables",
        },
        {
          title: "liveLoadFactor",
          path: "liveLoadFactor",
          type: "number",
          valuetype: "number",
          filtered: false,
          disabled: false,
          translationKey: "tables.designcombinations.liveLoadFactor",
          translationNamespace: "tables",
        },
      ],
    },
  ],
};

export default function DesignCombinations({ functions: designCombinationFunctions }) {
  const [currentPage, setCurrentPage] = useState(1);
  let pageSize = 20;

  const { isLoading, data: elements } = designCombinationFunctions.GetAll();

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    let res = elements?.slice(firstPageIndex, lastPageIndex);
    if (res?.length === 0 && currentPage !== 1) setCurrentPage(currentPage - 1);
    return res;
  }, [pageSize, currentPage, elements]);

  if (isLoading) return <p>loading...</p>;
  return (
    <>
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          {!isLoading && (
            <>
              <TableHeader
                headerDefs={designCombinationsHeaderDefinitions}
                translationPrefix={"tables.designcombinations"}
              />
              <TableBody
                columns={designCombinationsHeaderDefinitions.header[0].columns}
                currentTableData={currentTableData}
                functions={designCombinationFunctions}
              />
            </>
          )}
        </table>
      </div>

      {elements && (
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={elements?.length}
          pageSize={pageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      )}
    </>
  );
}
